import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/site/PageHero";
import { WorkGallery } from "@/components/site/WorkGallery";
import { CTAButtons } from "@/components/site/CTAButtons";
import { useWorkItems } from "@/lib/use-work-items";
import faceBgAssetUrl from "@/assets/izhub-face-bg.webp";
const faceBgAsset = { url: faceBgAssetUrl };

export const Route = createFileRoute("/our-work")({
  head: () => ({
    meta: [
      { title: "Our Cleaning Work & Before-and-After Photos | IZHUB" },
      { name: "description", content: "See domestic, deep, end of tenancy, Airbnb, commercial and military march-out cleaning work completed by IZHUB across Salisbury Plain." },
      { property: "og:title", content: "Our Cleaning Work | IZHUB Cleaning Services" },
      { property: "og:description", content: "Browse real cleaning work from homes, short-lets, offices and military accommodation across Salisbury Plain." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/our-work" }],
  }),
  component: OurWorkPage,
});

function OurWorkPage() {
  const workItems = useWorkItems();
  return (
    <>
      <PageHero
        title={<>Our cleaning work, <span className="rainbow-text">up close</span>.</>}
        intro="Browse real examples of our domestic, deep, tenancy, short-let, commercial and military march-out cleaning."
        withBackground
        backgroundImage={faceBgAsset.url}
      >
        <CTAButtons />
      </PageHero>
      <section className="bg-background/85 py-16 backdrop-blur-sm md:py-24">
        <div className="container-x">
          <WorkGallery items={workItems} showFilters />
        </div>
      </section>
    </>
  );
}